// // src/core/store/addCustomerSlice.ts

// import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// export interface AddCustomerData {
//   fullName: string;
//   lastName: string;
//   nationalCode: string;
//   birthDate: string;
//   gender: string;
//   province: string;
//   city: string;
//   address: string;
//   postalCode: string;
//   townshipId?: number | null;
// }

// interface AddCustomerState {
//   selectedRole: "customer" | null;
//   addCustomerData: AddCustomerData;
//   isComplete: boolean;
// }

// const initialState: AddCustomerState = {
//   selectedRole: "customer",
//   addCustomerData: {
//     fullName: "",
//     lastName: "",
//     nationalCode: "",
//     birthDate: "",
//     gender: "",
//     province: "",
//     city: "",
//     address: "",
//     postalCode: "",
//     townshipId: null,
//   },
//   isComplete: false,
// };

// const addCustomerSlice = createSlice({
//   name: "addCustomer",
//   initialState,
//   reducers: {
//     // تنظیم نقش
//     setAddCustomerRole: (state, action: PayloadAction<"customer">) => {
//       state.selectedRole = action.payload;
//     },

//     // آپدیت جزئی اطلاعات
//     updateAddCustomerData: (
//       state,
//       action: PayloadAction<Partial<AddCustomerData>>
//     ) => {
//       state.addCustomerData = {
//         ...state.addCustomerData,
//         ...action.payload,
//       };
//     },

//     // ست کامل اطلاعات
//     setAddCustomerData: (state, action: PayloadAction<AddCustomerData>) => {
//       state.addCustomerData = action.payload;
//     },

//     // تکمیل فرم
//     completeAddCustomer: (state) => {
//       state.isComplete = true;
//     },

//     // ریست کامل فرم
//     resetAddCustomer: () => initialState,
//   },
// });

// export const {
//   setAddCustomerRole,
//   updateAddCustomerData,
//   setAddCustomerData,
//   completeAddCustomer,
//   resetAddCustomer,
// } = addCustomerSlice.actions;

// export default addCustomerSlice.reducer;


// src/core/store/addCustomerSlice.ts

// import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

// export interface AddCustomerData {
//   // اطلاعات فردی
//   fullName: string;
//   lastName: string;
//   nationalCode: string;
//   birthDate: string;
//   gender: string;
//   province: string;
//   city: string;
//   address: string;
//   postalCode: string;
//   townshipId?: number | null;
//   // اطلاعات بانکی
//   bank?: string;
//   bankId?: number | null;
//   accountNumber?: string;
//   openingDate?: string;
//   gpaPrediction?: number | null;
//   plan?: string;
//   planId?: number | null;
// }

// interface AddCustomerState {
//   selectedRole: "customer" | null;
//   addCustomerData: AddCustomerData;
//   isComplete: boolean;
//   step: 1 | 2; // مرحله فعلی
// }

// const initialState: AddCustomerState = {
//   selectedRole: "customer",
//   addCustomerData: {
//     fullName: "",
//     lastName: "",
//     nationalCode: "",
//     birthDate: "",
//     gender: "",
//     province: "",
//     city: "",
//     address: "",
//     postalCode: "",
//     townshipId: null,
//     bank: "",
//     bankId: null,
//     accountNumber: "",
//     openingDate: "",
//     gpaPrediction: null,
//     plan: "",
//     planId: null,
//   },
//   isComplete: false,
//   step: 1,
// };

// const addCustomerSlice = createSlice({
//   name: "addCustomer",
//   initialState,
//   reducers: {
//     // تنظیم نقش
//     setAddCustomerRole: (state, action: PayloadAction<"customer">) => {
//       state.selectedRole = action.payload;
//     },

//     // آپدیت جزئی اطلاعات
//     updateAddCustomerData: (
//       state,
//       action: PayloadAction<Partial<AddCustomerData>>
//     ) => {
//       state.addCustomerData = {
//         ...state.addCustomerData,
//         ...action.payload,
//       };
//     },

//     // ست کامل اطلاعات
//     setAddCustomerData: (state, action: PayloadAction<AddCustomerData>) => {
//       state.addCustomerData = {
//         ...state.addCustomerData,
//         ...action.payload,
//       };
//     },

//     // آپدیت اطلاعات بانکی
//     setBankingData: (
//       state,
//       action: PayloadAction<{
//         bank: string;
//         bankId: number;
//         accountNumber: string;
//         openingDate: string;
//         gpaPrediction: number;
//         plan: string;
//         planId: number;
//       }>
//     ) => {
//       state.addCustomerData.bank = action.payload.bank;
//       state.addCustomerData.bankId = action.payload.bankId;
//       state.addCustomerData.accountNumber = action.payload.accountNumber;
//       state.addCustomerData.openingDate = action.payload.openingDate;
//       state.addCustomerData.gpaPrediction = action.payload.gpaPrediction;
//       state.addCustomerData.plan = action.payload.plan;
//       state.addCustomerData.planId = action.payload.planId;
//     },

//     // تغییر مرحله
//     setStep: (state, action: PayloadAction<1 | 2>) => {
//       state.step = action.payload;
//     },

//     // تکمیل فرم
//     completeAddCustomer: (state) => {
//       state.isComplete = true;
//     },

//     // ریست کامل فرم
//     resetAddCustomer: () => initialState,
//   },
// });

// export const {
//   setAddCustomerRole,
//   updateAddCustomerData,
//   setAddCustomerData,
//   setBankingData,
//   setStep,
//   completeAddCustomer,
//   resetAddCustomer,
// } = addCustomerSlice.actions;

// export default addCustomerSlice.reducer;


import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface AddCustomerData {
  // نوع کاربر (حقیقی/حقوقی)
  userType?: string;
  // اطلاعات فردی (حقیقی)
  fullName: string;
  lastName: string;
  nationalCode: string;
  birthDate: string;
  gender: string;
  mobileNumber: string;
  // اطلاعات حقوقی
  companyName?: string;
  companyNationalId?: string;
  employeeCount?: string;
  phoneNumber?: string;
  // اطلاعات آدرس (برای حقوقی)
  province: string;
  city: string;
  address: string;
  postalCode: string;
  townshipId?: number | null;
  // اطلاعات بانکی
  bank?: string;
  bankId?: number | null;
  accountNumber?: string;
  openingDate?: string;
  gpaPrediction?: number | null;
  plan?: string;
  planId?: number | null;
}

interface AddCustomerState {
  selectedRole: "customer" | null;
  addCustomerData: AddCustomerData;
  isComplete: boolean;
  step: 1 | 2;
}

const initialState: AddCustomerState = {
  selectedRole: "customer",
  addCustomerData: {
    userType: "NATURAL",
    fullName: "",
    lastName: "",
    nationalCode: "",
    birthDate: "",
    gender: "",
    mobileNumber: "",
    companyName: "",
    companyNationalId: "",
    employeeCount: "",
    phoneNumber: "",
    province: "",
    city: "",
    address: "",
    postalCode: "",
    townshipId: null,
    bank: "",
    bankId: null,
    accountNumber: "",
    openingDate: "",
    gpaPrediction: null,
    plan: "",
    planId: null,
  },
  isComplete: false,
  step: 1,
};

const addCustomerSlice = createSlice({
  name: "addCustomer",
  initialState,
  reducers: {
    setAddCustomerRole: (state, action: PayloadAction<"customer">) => {
      state.selectedRole = action.payload;
    },

    updateAddCustomerData: (
      state,
      action: PayloadAction<Partial<AddCustomerData>>
    ) => {
      state.addCustomerData = {
        ...state.addCustomerData,
        ...action.payload,
      };
    },

    setAddCustomerData: (state, action: PayloadAction<any>) => {
      // مهم: کل آبجکت را با مقادیر جدید جایگزین کن
      state.addCustomerData = {
        ...state.addCustomerData,
        ...action.payload,
      };
    },

    setBankingData: (
      state,
      action: PayloadAction<{
        bank: string;
        bankId: number;
        accountNumber: string;
        openingDate: string;
        gpaPrediction: number;
        plan: string;
        planId: number;
      }>
    ) => {
      state.addCustomerData.bank = action.payload.bank;
      state.addCustomerData.bankId = action.payload.bankId;
      state.addCustomerData.accountNumber = action.payload.accountNumber;
      state.addCustomerData.openingDate = action.payload.openingDate;
      state.addCustomerData.gpaPrediction = action.payload.gpaPrediction;
      state.addCustomerData.plan = action.payload.plan;
      state.addCustomerData.planId = action.payload.planId;
    },

    setStep: (state, action: PayloadAction<1 | 2>) => {
      state.step = action.payload;
    },

    completeAddCustomer: (state) => {
      state.isComplete = true;
    },

    resetAddCustomer: () => initialState,
  },
}); 

export const {
  setAddCustomerRole,
  updateAddCustomerData,
  setAddCustomerData,
  setBankingData,
  setStep,
  completeAddCustomer,
  resetAddCustomer,
} = addCustomerSlice.actions;

export default addCustomerSlice.reducer;